import {Observable} from "rxjs";
import {Country} from "../dtos/country";
import {Province} from "../dtos/province";
import {Workplace} from "../dtos/workplace";

export abstract class MasterDataRemote {
    public abstract getWorkplaces(): Observable<Workplace[]>;
    public abstract getCountries(): Observable<Country[]>;
    public abstract getProvinces(countryCode: string): Observable<Province[]>;
}
